var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightAdvertisement = function SvgArrowRightAdvertisement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 200,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H0v200h3l24-100L3 0Z",
    fill: "#E1F7F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100 0 200V0l24 100Z"
  })));
};
export default SvgArrowRightAdvertisement;